import { Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { getPolicyCardDetail } from '@/services/policy';
import './index.less';

export default function Detail() {
  const { search } = useLocation();
  const { data, loading } = useRequest(() => getPolicyCardDetail(qs.parse(search).id));

  return (
    <div className="policy-card-detail">
      <Spin spinning={loading}>
        <div className="content-width">
          <div className="policy-card-detail__title">{data?.title}</div>
          <div>
            发布时间：
            {data?.gmtPublish}
          </div>
          <div className="policy-card-detail__con">
            <div>
              <div className="policy-card-detail__label">政策类型：</div>
              <div>{data?.typeName}</div>
            </div>

            <div>
              <div className="policy-card-detail__label">支持对象：</div>
              <div>
                <div>{data?.supportObjectName}</div>
                <div>
                  {data?.supportObjectOther && '其他：'}
                  {data?.supportObjectOther}
                </div>
              </div>
            </div>
            <div>
              <div className="policy-card-detail__label">支持内容：</div>
              <div>{data?.supportingContent}</div>
            </div>
            <div>
              <div className="policy-card-detail__label">补助补贴标准：</div>
              <div>{data?.subsidyStandard}</div>
            </div>
            <div>
              <div className="policy-card-detail__label">申报条件：</div>
              <div>{data?.declarationConditions}</div>
            </div>
            <div>
              <div className="policy-card-detail__label">申报程序：</div>
              <div>{data?.declarationProcedure}</div>
            </div>
            <div>
              <div className="policy-card-detail__label">其他：</div>
              <div>{data?.remark}</div>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
}
